import { render, staticRenderFns } from "./PopupApprovalHistory.vue?vue&type=template&id=f5631da4&scoped=true&"
import script from "./PopupApprovalHistory.vue?vue&type=script&lang=js&"
export * from "./PopupApprovalHistory.vue?vue&type=script&lang=js&"
import style0 from "./PopupApprovalHistory.vue?vue&type=style&index=0&id=f5631da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5631da4",
  null
  
)

export default component.exports